import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY || "AIzaSyCTB083jR3aZRBF28KpL_2rmMM0eHUu6lc",
  authDomain: process.env.FIREBASE_AUTH_DOMAIN || "iqodex365.firebaseapp.com",
  projectId: process.env.FIREBASE_PROJECT_ID || "iqodex365",
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET || "iqodex365.firebasestorage.app",
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "779166807407",
  appId: process.env.FIREBASE_APP_ID || "1:779166807407:web:eda895951bc288a313a49a",
  measurementId: "G-XL2WGLYX8S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// Initialize Analytics (safely, as it requires window/browser environment)
let analytics;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn("Firebase Analytics failed to initialize:", e);
  }
}

console.log("🔥 Firebase initialized successfully.");

// Export auth and db, but NOT storage
export { db, analytics, auth };